import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import includeAnalytics from 'redux/modules/analytics/HOC';

import {
  isHandlingOpened,
  getSelectedAgent,
  getIsLoading,
} from 'redux/modules/journey-handling/selectors';

import {
  closeHandlingModal,
  assignAgent,
  selectAgent,
} from 'redux/modules/journey-handling/effects';

import AssignAgentModal from './component';

const enhance = compose(
  includeAnalytics,
  connect(
    (state) => ({
      show: isHandlingOpened(state),
      selectedAgent: getSelectedAgent(state),
      loading: getIsLoading(state),
    }),
    {
      onClose: closeHandlingModal,
      onAssign: assignAgent,
      selectAgent,
    }
  ),
  withHandlers({
    onSelect:
      ({ selectAgent }) =>
      (value) => {
        selectAgent(value);
      },
  })
);

export default enhance(AssignAgentModal);
